import { Logo } from "@/components/landing/Logo";
import { useContent } from "@/context/ContentContext";

const footerLinks = [
  { label: "About Us", href: "/about", testid: "footer-link-about" },
  { label: "Terms & Conditions", href: "/terms", testid: "footer-link-terms" },
  { label: "Contact", href: "/#contact", testid: "footer-link-contact" },
];

export const Footer = () => {
  const { content } = useContent();
  const f = content?.footer;

  return (
    <footer data-testid="site-footer" className="bg-[#122A1D] border-t border-[#C8A24A]/20 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <a href="/" data-testid="footer-logo-link">
            <Logo tone="light" />
          </a>
          <nav className="flex flex-wrap items-center justify-center gap-8">
            {footerLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={l.testid}
                className="text-xs uppercase tracking-[0.25em] text-[#A3B8AD] hover:text-[#E3C97A] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <p className="font-heading text-[#C8A24A]/80 text-lg italic">
            {f?.tagline || "In the name of Allah, we begin"}
          </p>
        </div>
        <p className="mt-10 pt-6 border-t border-[#C8A24A]/15 text-xs uppercase tracking-[0.25em] text-[#A3B8AD]/70 text-center">
          © {new Date().getFullYear()} {f?.copyright_name || "786 Interactive — 786i.net"}
        </p>
      </div>
    </footer>
  );
};
